export const LOAD_GATEWAY = 'metrics/LOAD_GATEWAY';
export const LOAD_GATEWAY_SUCCESS = 'metrics/LOAD_GATEWAY_SUCCESS';
export const LOAD_GATEWAY_NOT_FOUND = 'metrics/LOAD_GATEWAY_NOT_FOUND';
export const LOAD_GATEWAY_ERROR = 'metrics/LOAD_GATEWAY_ERROR';
export const LOAD_METRICS = 'metrics/LOAD_METRICS';
export const LOAD_ALL_METRICS = 'metrics/LOAD_ALL_METRICS';
export const LOAD_METRICS_SUCCESS = 'metrics/LOAD_METRICS_SUCCESS';
export const LOAD_METRICS_ERROR = 'metrics/LOAD_METRICS_ERROR';
export const LOAD_PATH = 'metrics/LOAD_PATH';
export const LOAD_PATH_SUCCESS = 'metrics/LOAD_PATH_SUCCESS';
export const LOAD_PATH_ERROR = 'metrics/LOAD_PATH_ERROR';
export const LOAD_PATH_NOT_FOUND = 'metrics/LOAD_PATH_NOT_FOUND';
export const LOAD_METRICS_ALL = 'metrics/LOAD_METRICS_ALL';
export const LOAD_METRICS_GATEWAY = 'metrics/LOAD_METRICS_GATEWAY';
export const LOAD_METRICS_GATEWAY_SUCCESS = 'metrics/LOAD_METRICS_GATEWAY_SUCCESS';
export const LOAD_HOST_METRICS = 'metrics/LOAD_HOST_METRICS';
export const LOAD_HOST_METRICS_SUCCESS = 'metrics/LOAD_HOST_METRICS_SUCCESS';
